import { general } from './general';
import { text } from './text';
import { email } from './email';
import { notapplicable } from './notapplicable';
import { location } from './location';
import { telephone } from './telephone';
import { branch } from './branch';
import { textarea } from './textarea';
import { name } from './name';
import { collection, emailCollection, telephoneCollection } from './collection';

export const supervisor = (data = {}) => general('supervisor', {
  SupervisorName: text(data?.SupervisorName),
  SupervisorNamePvq: name(data?.SupervisorNamePvq),
  Title: text(data?.Title),
  SupervisorAssignedUnitOrg: text(data?.SupervisorAssignedUnitOrg),
  Email: email(data?.Email),
  EmailNotApplicable: notapplicable(data?.EmailNotApplicable),
  Address: location(data?.Address),
  Telephone: telephone(data?.Telephone),
  HasDifferentSupervisorAddress: branch(data?.HasDifferentSupervisorAddress),
  Comments: textarea(data?.Comments),
  TitleNotApplicable: notapplicable(data?.TitleNotApplicable),
  SupervisorAssignedUnitOrgNotApplicable: notapplicable(data?.SupervisorAssignedUnitOrgNotApplicable),
  AddressNotApplicable: notapplicable(data?.AddressNotApplicable),
  InUsaNotApplicable: notapplicable(data?.InUsaNotApplicable),
  Telephones: collection(telephoneCollection(data?.Telephones)), // PVQ Only
  Emails: collection(emailCollection(data?.Emails)), // PVQ Only
});
